import api from './api';

export async function fetchQuestionBankSubjects(params = {}) {
  const response = await api.get('/subjects', {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionBankSubjectDetail(params = {}) {
  const response = await api.get('/subject-detail', {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function updateQuestionBankTopicToggle(payload = {}) {
  const response = await api.post('/topic-subtopic-toggle-status', payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
